import { defineMessages } from 'react-intl';

export default defineMessages({
  boards: 'Boards',
  messageBoards: 'Message Boards',
  noResultsText: 'Sorry. Your search did not return any results. Please try again.'
});
